<template>
  <div class="ips-login__wrapper">
    <div class="ips-login__container">

      <login-header/>

      <login-background>

        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>

      </login-background>

      <login-footer/>
    </div>
  </div>
</template>

<script>
import LoginHeader from './views/login/components/LoginHeader.vue'
import LoginFooter from './views/login/components/LoginFooter.vue'
import LoginBackground from './views/login/components/LoginBackground.vue'

export default {
  data() {
    return {
      componentName: ""
    };
  },
  mounted() {

    if (location.pathname.indexOf("login.html") > -1) {
      this.componentName = "Justbon";
    } else {
      this.componentName = "Jcp";
    }
  },
  components: {
     LoginHeader
    , LoginFooter
    , LoginBackground
  }
};
</script>

<style lang="scss">
@import "./assets/scss/utils";
@import "./assets/scss/app";
@import "./assets/scss/login";

.ips-login__wrapper{
  // 背景图的定位
  background-image: url("./assets/images/justbon/login_background_sl.png");
}
</style>
